// generic-client

import compose from 'lodash.flowright';
import { removeNotification } from 'lib/apollo/clientSchema/Notification';

const NotificationsContainer = (Notifications) =>
  compose(
    (Component) =>
      function NotificationsContainerWrapper(props) {
        return <Component {...props} removeNotification={({ id }) => removeNotification(id)} />;
      },
  )(Notifications);

export default NotificationsContainer;
